export enum SortByTypeEnum {
    None = "",
    Asc = "asc",
    Desc = "desc",
}